import {
    Connectga2Blue,
    DcwalletBlue,
    SignalsrestapiBlue,
    SignalsrestapiwalletBlue,
} from "@similarweb/icons/illustrations";

import {
    StyledConnectGAIllustrationWrapper,
    StyledDCWalletIllustrationWrapper,
} from "../../containers/GatewayPageContainer/styles";

const CONNECT_GA_SIZE = 386;
const DC_WALLET_SIZE = 218;
const SIGNALS_REST_API_GATEWAY_ILLUSTRATION_SIZE = 280;
const SIGNALS_REST_API_WALLET_ILLUSTRATION_SIZE = 240;

export const renderConnectGAIllustration = () => (
    <StyledConnectGAIllustrationWrapper>
        <Connectga2Blue size={CONNECT_GA_SIZE} />
    </StyledConnectGAIllustrationWrapper>
);

export const renderDCWalletIllustration = () => (
    <StyledDCWalletIllustrationWrapper>
        <DcwalletBlue size={DC_WALLET_SIZE} />
    </StyledDCWalletIllustrationWrapper>
);

export const renderSignalsRestApiInfoIllustration = () => (
    <StyledConnectGAIllustrationWrapper>
        <SignalsrestapiBlue size={SIGNALS_REST_API_GATEWAY_ILLUSTRATION_SIZE} />
    </StyledConnectGAIllustrationWrapper>
);

export const renderSignalsRestApiCreditsIllustration = () => (
    <StyledDCWalletIllustrationWrapper>
        <SignalsrestapiwalletBlue size={SIGNALS_REST_API_WALLET_ILLUSTRATION_SIZE} />
    </StyledDCWalletIllustrationWrapper>
);
